(function () {
'use strict';

angular
    .module('riskSelfAssessmentListRoutes', [
        'riskModule',
        'riskSelfAssessmentListControllers'
    ])
    .config(router);

    router.$inject = ['$stateProvider'];

    function router($stateProvider) {
        $stateProvider
             .state('riskSelfAssessmentList', {
                 url: '/RiskSelfAssessment',
                 data: {
                     permissions: { featureRole: 'GRCRcsaManagement', key: 'Risk', permission: 'Review' }
                 },
                 resolve: {
                     govProcess: ['grcGovernanceProcessService', function (service) {
                         return service.getActiveRiskSelfAssessments();
                     }],
                     assessors: ['commonRiskSelfAssessmentService', function (service) {
                         return service.statusAssessorsList();
                     }]
                 },
                 templateUrl: require('./riskSelfAssessmentList.tpl.html'),
                 controller: 'RiskSelfAssessmentListController'
             });
    }
})();
